import React, { lazy } from 'react';
import BonusCarousel from './BonusCarousel';
const OfferBonuses = () => {
  return <section className="py-16 bg-white" data-id="element-186">
      <div className="container mx-auto px-4" data-id="element-187">
        <div className="text-center mb-12" data-id="element-188">
          <h2 className="text-2xl md:text-3xl font-bold mb-4 text-gray-800" data-id="element-189">
            Lo que recibirás hoy
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-190">
            Acceso inmediato a todo el sistema + 3 bonos exclusivos de regalo
          </p>
        </div>
        <div className="bg-gradient-to-r from-custom-brown to-custom-brown-light p-1 rounded-xl mb-12" data-id="element-191">
          <div className="bg-white p-6 md:p-8 rounded-lg" data-id="element-192">
            <div className="flex flex-col md:flex-row" data-id="element-193">
              <div className="w-full md:w-1/3 mb-6 md:mb-0 md:pr-8" data-id="element-194">
                <div className="img-container aspect-ratio-4-3 shadow-lg rounded-lg" data-id="element-195">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vM312hyUcELjknqCsfveZF/7_recetas_portada.jpg" alt="7 Cenas Latinas en 30 Minutos" className="img-content" width="400" height="300" loading="lazy" onError={e => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = 'https://via.placeholder.com/400x300/f5f5f5/a97142?text=Portada+Libro';
                }} data-id="element-196" />
                </div>
              </div>
              <div className="w-full md:w-2/3" data-id="element-197">
                <h3 className="text-2xl font-bold mb-4 text-gray-800" data-id="element-198">
                  Ebook "7 Cenas Latinas en 30 Minutos – Método Exprés Latino"
                </h3>
                <ul className="space-y-3 mb-6" data-id="element-199">
                  <li className="flex items-start" data-id="element-200">
                    <span className="text-custom-brown mr-2 font-bold" data-id="element-201">✓</span>
                    <span data-id="element-202">
                      7 recetas latinas paso a paso con fotos e instrucciones
                      detalladas
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-203">
                    <span className="text-custom-brown mr-2 font-bold" data-id="element-204">✓</span>
                    <span data-id="element-205">Lista de compras optimizada para ahorrar dinero</span>
                  </li>
                  <li className="flex items-start" data-id="element-206">
                    <span className="text-custom-brown mr-2 font-bold" data-id="element-207">✓</span>
                    <span data-id="element-208">
                      Guía de batch cooking en 2 horas para toda la semana
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-209">
                    <span className="text-custom-brown mr-2 font-bold" data-id="element-210">✓</span>
                    <span data-id="element-211">Variaciones creativas para cada receta</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <h3 className="text-2xl font-bold text-center mb-8 text-gray-800" data-id="element-212">
          + 3 Bonos Exclusivos (Valor $83 USD)
        </h3>
        {/* Mobile Carousel (only shown on small screens) */}
        <div className="md:hidden" data-id="element-213">
          <BonusCarousel data-id="element-214" />
        </div>
        {/* Desktop Grid (hidden on small screens) */}
        <div className="hidden md:grid grid-cols-3 gap-8 mb-12" data-id="element-215">
          <div className="bg-amber-50 p-6 rounded-lg" data-id="element-216">
            <div className="mb-4 mobile-img-fix h-48 flex items-center justify-center" data-id="element-217">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tTBysf5DnKWQBY6JHw9nbK/Bono_1_-_Planificador_semanal.jpg" alt="Planificador Semanal Express" className="max-h-full" width="200" height="200" loading="lazy" onError={e => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = 'https://via.placeholder.com/200x200/f5f5f5/a97142?text=Planificador';
            }} data-id="element-218" />
            </div>
            <h4 className="text-xl font-bold mb-2 text-gray-800" data-id="element-219">
              Planificador Semanal Express
            </h4>
            <p className="text-gray-600 mb-4" data-id="element-220">
              Plantilla imprimible para organizar tus comidas, compras y
              preparaciones de la semana en solo 10 minutos.
            </p>
            <p className="font-bold text-custom-brown" data-id="element-221">Valor: $27 USD</p>
          </div>
          <div className="bg-amber-50 p-6 rounded-lg" data-id="element-222">
            <div className="mb-4 mobile-img-fix h-48 flex items-center justify-center" data-id="element-223">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/btzWphdbCf5LGUBQqEAe6q/Bono_2_-_Guia_de_aderezos.jpg" alt="Guía de Salsas y Aderezos Latinos" className="max-h-full" width="200" height="200" loading="lazy" onError={e => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = 'https://via.placeholder.com/200x200/f5f5f5/a97142?text=Guía+Salsas';
            }} data-id="element-224" />
            </div>
            <h4 className="text-xl font-bold mb-2 text-gray-800" data-id="element-225">
              Guía de Salsas y Aderezos Latinos
            </h4>
            <p className="text-gray-600 mb-4" data-id="element-226">
              15 recetas de salsas y acompañamientos para elevar tus cenas y
              darles un toque especial.
            </p>
            <p className="font-bold text-custom-brown" data-id="element-227">Valor: $19 USD</p>
          </div>
          <div className="bg-amber-50 p-6 rounded-lg" data-id="element-228">
            <div className="mb-4 mobile-img-fix h-48 flex items-center justify-center" data-id="element-229">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eMXr3uhhkgmGpNUSwfG7Mu/Bono_3_-_Reto_7_dias_menos_estres.jpg" alt="Reto 7 Días: Cocina Organizada, Vida Organizada" className="max-h-full" width="200" height="200" loading="lazy" onError={e => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = 'https://via.placeholder.com/200x200/f5f5f5/a97142?text=Reto+7+Días';
            }} data-id="element-230" />
            </div>
            <h4 className="text-xl font-bold mb-2 text-gray-800" data-id="element-231">
              Reto 7 Días: Cocina Organizada, Vida Organizada
            </h4>
            <p className="text-gray-600 mb-4" data-id="element-232">
              Guía paso a paso para implementar el sistema y transformar tu
              rutina en solo una semana.
            </p>
            <p className="font-bold text-custom-brown" data-id="element-233">Valor: $37 USD</p>
          </div>
        </div>
        {/* Mockup Image */}
        <div className="max-w-3xl mx-auto mb-12" data-id="element-234">
          <div className="img-container aspect-ratio-16-9 shadow-lg rounded-lg" data-id="element-235">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dvCEmTAt6PzjyLubtKgyKY/Mockup.jpg" alt="Libros del Método Exprés Latino" className="img-content" width="800" height="450" loading="lazy" onError={e => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = 'https://via.placeholder.com/800x450/f5f5f5/a97142?text=Libros+Método+Exprés';
          }} data-id="element-236" />
          </div>
        </div>
        <div className="text-center" data-id="element-237">
          <div className="flex flex-col sm:flex-row items-center justify-center" data-id="element-238">
            <a href="https://pay.hotmart.com/W101891326K?checkoutMode=10" className="bg-white text-custom-brown hover:bg-custom-brown hover:text-white border border-custom-brown font-bold py-4 px-10 rounded-lg text-xl transition duration-300 shadow-lg" onClick={() => {
            if (window.fbq) window.fbq('track', 'AddToCart', {
              content_name: '7 Cenas Latinas en 30 Minutos',
              content_type: 'product',
              value: 7.0,
              currency: 'USD'
            });
          }} data-id="element-239">
              Llevarme mi ebook + 3 bonos gratis - $7.00
            </a>
          </div>
          <p className="mt-3 text-custom-brown font-medium" data-id="element-240">
            <del className="text-gray-500" data-id="element-241">$83</del> - ahorras $77
          </p>
        </div>
      </div>
    </section>;
};
export default OfferBonuses;